<template>
  <div class="riseup-bot">
    <img class="logo" :src="require('../assets/bot-logo.png')">
    <div class="details">
      <div class="text">הבוט של riseup</div>
      <div class="date">{{ this.formattedMsgDate }}</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'RiseupBot',
  props: {
    botUpdateTime: Date,
  },
  computed: {
    formattedMsgDate() {
      return moment(this.botUpdateTime).format('D.M.YY, HH:mm');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../scss/riseup-colors';

  .riseup-bot {
    direction: rtl;
    font-family: SimplerPro;
    display: flex;
    flex-direction: row;
    height: 40px;

    .logo {
      height: 40px;
    }

    .details {
      text-align: right;
      padding: 8px;
      font-size: 10px;

      .text {
        font-weight: bold;
      }

      .date {
        padding-top: 7px;
        color: $riseup_gray_2;
      }
    }
  }
</style>
